module.exports = __webpack_public_path__ + "static/img/2.eee6575.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/2.png
// module id = asUn
// module chunks = 0